import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import {
  fetchInsuranceRegister,
  fetchInsuranceModify,
  fetchInsuranceDelete,
  initializeState,
  updateHouseLabel,
  updateHouseNo,
  updateCompanyCode,
  updateProductSequence,
  updateStartYearMonth,
  updateSubscriptionPeriod,
} from '@Root/slices/myhouse/insuranceRegister'
import { RootState } from '@Root/slices'
import InsuranceHouseResponse from '@Types/entities/InsuranceHouseResponse'

export default function useInsuranceRegister() {
  const dispatch = useDispatch()
  const insuranceRegister = useSelector((state: RootState) => state.insuranceRegister)

  const setHouseLabel = useCallback(
    (house: InsuranceHouseResponse) => {
      dispatch(updateHouseLabel(house))
    },
    [dispatch],
  )

  const setInitialState = useCallback(() => {
    dispatch(initializeState())
  }, [dispatch])
  const setCompanyCode = useCallback(
    (value: string) => {
      dispatch(updateCompanyCode(value))
    },
    [dispatch],
  )
  const setHouseNo = useCallback(
    (value: number) => {
      dispatch(updateHouseNo(value))
    },
    [dispatch],
  )
  const setProductSequence = useCallback(
    (value: number) => {
      dispatch(updateProductSequence(value))
    },
    [dispatch],
  )
  const setStartYearMonth = useCallback(
    (value: string) => {
      dispatch(updateStartYearMonth(value))
    },
    [dispatch],
  )
  const setSubscriptionPeriod = useCallback(
    (value: number) => {
      dispatch(updateSubscriptionPeriod(value))
    },
    [dispatch],
  )

  const loadInsuranceRegister = useCallback(
    (param): void => {
      dispatch(fetchInsuranceRegister(param))
    },
    [dispatch],
  )

  const loadInsuranceModify = useCallback(
    (param, insuranceSequence): void => {
      dispatch(fetchInsuranceModify({ param, insuranceSequence }))
    },
    [dispatch],
  )

  const loadInsuranceDelete = useCallback(
    (param): void => {
      dispatch(fetchInsuranceDelete(param))
    },
    [dispatch],
  )

  return {
    insuranceRegister,
    loadInsuranceRegister,
    loadInsuranceModify,
    loadInsuranceDelete,
    setHouseLabel,
    setInitialState,
    setHouseNo,
    setCompanyCode,
    setProductSequence,
    setStartYearMonth,
    setSubscriptionPeriod,
  }
}
